export const CYPRESS_COMMANDS_NAMESPACE = 'cypress-commands';
export const MERCHANT_PORTAL_SESSION_UTILS_NAMESPACE = 'merchant-portal-session-utils';
export const MERCHANT_PORTAL_WIDGET_UTILS_NAMESPACE = 'merchant-portal-widget-utils';
export const MOCKED_MERCHANT_NAMESPACE = 'mocked-merchant';
export const MOET_CLI_NAMESPACE = 'moet-cli';
export const SPEC_UTILS_NAMESPACE = 'spec-utils';

export const DEBUG_LEVELS = {
  LOG: 'LOG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
};

const NUMERIC_DEBUG_LEVELS = {
  LOG: 1000,
  INFO: 2000,
  WARN: 3000,
  ERROR: 4000,
};

export function setVerboseMode(mode = true) {
  if (process && process.env) {
    process.env.verbose = true;
  }
}

export function isVerboseMode() {
  return process && process.env && process.env.verbose;
}

export function setDebugMode(debugDependency) {
  return (debuggerInstance, logLvl, extraFilters = []) => {
    const modeFilter = getLogLvlFilter(debuggerInstance, logLvl);
    const previousFilters = (debugDependency.load() || '').split(',');
    debugDependency.enable([...previousFilters, ...modeFilter, ...extraFilters].join(','));
  };
}

export function debugBuilder(debugDependency) {
  return namespace => {
    const result = {
      labels: {},
      namespace,
    };
    Object.keys(DEBUG_LEVELS).forEach(lvl => {
      const label = `${namespace}:${lvl}`;
      result[lvl.toLowerCase()] = debugDependency(label);
      result.labels[lvl] = label;
    });
    return result;
  };
}

function getLogLvlFilter(debuggerInstance, logLvl) {
  const currentValue = NUMERIC_DEBUG_LEVELS[logLvl];
  const filter = [];
  Object.keys(DEBUG_LEVELS).forEach(lvl => {
    filter.push(
      `${NUMERIC_DEBUG_LEVELS[lvl] < currentValue ? '-' : ''}${debuggerInstance.labels[lvl]}`,
    );
  });
  return filter;
}
